import { useState, useEffect } from "react";
import "./i18n";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";

import ScrollToTop from "./components/ScrollToTop";
import LanguageProvider from "./components/LanguageProvider";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";

import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import ThankYou from "./pages/ThankYou";

function NotFoundInLang() {
  const { lang = "fr" } = useParams();
  return <Navigate to={`/${lang}`} replace />;
}

function LangLayout({ onOpenPrefs }) {
  return (
    <LanguageProvider>
      <Header />
      <Routes>
        <Route index element={<Home />} />
        <Route path="privacy-policy" element={<LegalPage nsKey="privacy" testId="privacy-page" />} />
        <Route path="cookie-policy" element={<LegalPage nsKey="cookies" testId="cookies-page" />} />
        <Route path="terms" element={<LegalPage nsKey="terms" testId="terms-page" />} />
        <Route path="*" element={<NotFoundInLang />} />
      </Routes>
      <Footer onOpenCookiePrefs={onOpenPrefs} />
    </LanguageProvider>
  );
}

function ThankYouLocked() {
  // Force French locale on the Thank You page and revert on unmount.
  const { i18n } = useTranslation();
  useEffect(() => {
    const prev = i18n.language;
    i18n.changeLanguage("fr");
    document.documentElement.lang = "fr";
    return () => { i18n.changeLanguage(prev); };
  }, [i18n]);
  return <ThankYou />;
}

export default function App() {
  const [prefsSignal, setPrefsSignal] = useState(0);
  const openPrefs = () => setPrefsSignal((s) => s + 1);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/fr" replace />} />
        <Route path="/thank_you" element={<ThankYouLocked />} />
        <Route path="/:lang/*" element={<LangLayout onOpenPrefs={openPrefs} />} />
        <Route path="*" element={<Navigate to="/fr" replace />} />
      </Routes>
      <CookieBanner openSignal={prefsSignal} />
    </BrowserRouter>
  );
}
